const CHUNK_ERROR_RE = /Failed to fetch dynamically imported module|Importing a module script failed|Unable to preload CSS/i
const RELOAD_KEY = 'cs:chunk-reload-at'
const RELOAD_COOLDOWN_MS = 60_000

const tryReload = (err: unknown) => {
  const msg = err instanceof Error ? err.message : String((err as { message?: string })?.message ?? err ?? '')
  if (!CHUNK_ERROR_RE.test(msg)) return
  const last = Number(sessionStorage.getItem(RELOAD_KEY) ?? 0)
  if (Date.now() - last < RELOAD_COOLDOWN_MS) return
  sessionStorage.setItem(RELOAD_KEY, String(Date.now()))
  window.location.reload()
}

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.hook('app:chunkError', ({ error }) => tryReload(error))
  window.addEventListener('error', (e) => tryReload(e.error ?? e.message))
  window.addEventListener('unhandledrejection', (e) => tryReload(e.reason))
})
